<mat-card>
  <mat-card-content>
    <highcharts-chart [Highcharts]="linesHighcharts"
      [options]="linesChartOptions"
    class="chart"></highcharts-chart>

    <table mat-table
      [dataSource]="dataSource">

      <ng-container matColumnDef="pet">
        <th mat-header-cell
          *matHeaderCellDef>
        </th>
        <td mat-cell
          *matCellDef="let row">

          @if (row.pet) {
            <div class="pet-card">
              <img class="avatar"
                [src]="(row.pet.avatar || '/assets/images/pet.png') + '?size=small&scale=2'"
                onerror="this.src='/assets/images/pet.png';"/>
              <div class="info">
                <span class="alias">{{row.pet.alias}}</span>
              </div>
            </div>
          }
          @else {
            <div class="collar-card">
              <mat-icon svgIcon="collar"
              class="collar-icon"></mat-icon>
            </div>
          }

        </td>
      </ng-container>

      <ng-container matColumnDef="flash_error">
        <th mat-header-cell
          *matHeaderCellDef>Flash
        </th>
        <td mat-cell
          *matCellDef="let row">
          @if (row.flash_error) {
            <a [mat-dialog-close]="true"
              [routerLink]="row.pet ? ['customers', row.owner.id, 'pets', row.pet.id] : ['devices', row.collar.id]"
              [filter]="{id: row.flash_error.id}"
              filterLink="requests">
              {{row.flash_error.timestamp | utc | moment}}
            </a>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="battery_connection_error">
        <th mat-header-cell
          *matHeaderCellDef>Battery
        </th>
        <td mat-cell
          *matCellDef="let row">
          @if (row.battery_connection_error) {
            <a [mat-dialog-close]="true"
              [routerLink]="row.pet ? ['customers', row.owner.id, 'pets', row.pet.id] : ['devices', row.collar.id]"
              [filter]="{id: row.battery_connection_error.id}"
              filterLink="requests">
              {{row.battery_connection_error.timestamp | utc | moment}}
            </a>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="imu_error">
        <th mat-header-cell
          *matHeaderCellDef>IMU
        </th>
        <td mat-cell
          *matCellDef="let row">
          @if (row.imu_error) {
            <a [mat-dialog-close]="true"
              [routerLink]="row.pet ? ['customers', row.owner.id, 'pets', row.pet.id] : ['devices', row.collar.id]"
              [filter]="{id: row.imu_error.id}"
              filterLink="requests">
              {{row.imu_error.timestamp | utc | moment}}
            </a>
          }
        </td>
      </ng-container>

      <tr mat-header-row
      *matHeaderRowDef="columns"></tr>
      <tr mat-row
      *matRowDef="let row; columns: columns"></tr>
    </table>
  </mat-card-content>
</mat-card>
